// @ts-ignore
import { Howl } from "howler/dist/howler.core.min.js";

type UseSoundProps = {
  src: string;
} & Howl;

export const useSound = ({ src, ...props }: UseSoundProps) => {
  const sound: Howl = new Howl({
    src: [src],
    autoplay: false,
    ...props,
  });

  return sound;
};
